module.exports = __webpack_public_path__ + "static/img/act03.044756f.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/v2/act03.jpeg
// module id = Ycrt
// module chunks = 76